import React from 'react';
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';

const balanceSheetData = [
  {
    year: '2022',
    currentAssets: 1.25,
    fixedAssets: 1.6,
    totalAssets: 2.85,
    totalLiabilities: 1.8,
    totalEquity: 1.0,
  },
  {
    year: '2023',
    currentAssets: 1.46,
    fixedAssets: 1.8,
    totalAssets: 3.26,
    totalLiabilities: 2.05,
    totalEquity: 1.1,
  },
  {
    year: '2024',
    currentAssets: 1.67,
    fixedAssets: 2.0,
    totalAssets: 3.67,
    totalLiabilities: 2.31,
    totalEquity: 1.2,
  },
];

const formatCurrency = (value) => {
  return `$${value}M`;
};

const BalanceSheetBars = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Assets Overview</h3>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={balanceSheetData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="year" />
              <YAxis tickFormatter={formatCurrency} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Bar dataKey="currentAssets" fill="#3B82F6" name="Current Assets" />
              <Bar dataKey="fixedAssets" fill="#10B981" name="Fixed Assets" />
              <Bar dataKey="totalAssets" fill="#F59E0B" name="Total Assets" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Liabilities & Equity Overview</h3>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={balanceSheetData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="year" />
              <YAxis tickFormatter={formatCurrency} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Bar dataKey="totalLiabilities" fill="#EF4444" name="Total Liabilities" />
              <Bar dataKey="totalEquity" fill="#6366F1" name="Total Equity" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default BalanceSheetBars;
